import React from "react";
import { RenderProps } from "@models/carousel";
import { AuthorResponseModel } from "@models/users";
import { Variants, motion } from "framer-motion";
import ImageRenderer from "@components/common/Image";
import Title from "@components/common/Title";

export interface OneAuthorProps {
  author: AuthorResponseModel | undefined;
  direction: number;
  variants: Variants;
}
const OneAuthor: React.FunctionComponent<RenderProps<OneAuthorProps>> = ({
  data: { author, direction, variants },
}) => {
  const {
    id,
    firstName = "",
    lastName,
    profilePicture,
    subTitle = "",
    about = "",
  } = author ?? {};

  if (!author) return <></>;

  return (
    <motion.div
      key={id}
      className="flex items-start gap-6"
      custom={direction}
      initial="enter"
      animate="center"
      exit="exit"
      variants={variants}
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 },
      }}
    >
      {profilePicture && (
        <div className="rounded-full overflow-hidden">
          <ImageRenderer image={profilePicture} />
        </div>
      )}
      <div className="">
        <Title
          variant="tertiary"
          titleText={`${firstName} ${lastName}`}
          className="text-left"
        />
        <Title
          variant="paragraph"
          titleText={subTitle}
          className="text-left text-grey-90"
        />
        <Title
          variant="paragraph"
          titleText={about}
          className=" text-left max-w-[375px] mt-3"
        />
      </div>
    </motion.div>
  );
};

export default OneAuthor;
